// extracted by mini-css-extract-plugin
export default {"demoThumbnail":"exampleThumbnails_demoThumbnail__rO6El"};